'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();

import canUseDOM from '@/utilities/canUseDOM';
import {Locale, usePathname, useRouter} from '@/i18n/routing';
import React, { createContext, useContext, useRef } from 'react';

export interface LocaleContextType {
  locale: Locale;
  onLocaleSelect: (locale: Locale) => void;
  setPathMapping: (pathMapping: Record<string, string>) => void;
}

export const LocaleContext = createContext<LocaleContextType>({
  locale: 'nl',
  onLocaleSelect: () => {},
  setPathMapping: () => {}
});

export const LocaleProviderClient = ({
  children,
  locale
}: {
  children: React.ReactNode;
  locale: Locale;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const pathMappingRef = useRef<Record<string, string>>({});

  const determinePath = (_locale: Locale) => {
    const currentSlug = pathMappingRef.current[locale];
    const nextSlug = pathMappingRef.current[_locale];

    // No mapping set (e.g. non-dynamic pages) — keep pathname as-is
    if (!currentSlug) {
      return pathname;
    }

    // Target locale has no translated slug — navigate to parent listing page
    // e.g. /cases/dutch-slug → /cases
    if (!nextSlug) {
      const lastSlashIndex = pathname.lastIndexOf('/');
      return lastSlashIndex > 0 ? pathname.substring(0, lastSlashIndex) : pathname;
    }

    if (currentSlug === nextSlug) {
      return pathname;
    }

    return pathname.replace(currentSlug, nextSlug);
  };

  function onLocaleSelect(_locale: Locale) {
    if (!canUseDOM) return;
    try {
      const path = determinePath(_locale);
      if (path !== pathname || (_locale !== locale && window)) {
        router.push(path, { locale: _locale });
      }
    } catch (error) {
      console.error(error);
    }
  }

  const setPathMapping = (mapping: Record<string, string>) => {
    pathMappingRef.current = mapping;
  };

  return (
    <LocaleContext.Provider value={{ locale, onLocaleSelect, setPathMapping }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);
